module.exports = __webpack_public_path__ + "img/852315302e256f5c8a052ae762dde66c.png";